module.exports = __webpack_public_path__ + "media/images/new_home/location-c948c92907574a8ab2b9f61aabe976e4.svg";